import React from 'react';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface WarningInfoProps {
  description: string;
}

const WarningInfo = ({ description }: WarningInfoProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        padding: theme.spacing(1),
        display: 'flex',
        alignContent: 'center',
        borderRadius: '2px',
        gap: '2px',
        color: theme.palette.busmanColors.busmanRed,
      }}>
      <WarningAmberIcon sx={{ fontSize: '16px', color: '#FF2222', mt: '1px', opacity: 0.7 }} />
      <Typography variant="h6" sx={{ color: '#FF2222', opacity: 0.7 }} m={0}>
        <strong>{description}</strong>
      </Typography>
    </Box>
  );
};

export default WarningInfo;
